import React, { useState, useEffect } from 'react'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import Typography from '@material-ui/core/Typography'
import Slider from '@material-ui/core/Slider'

import { useProjectsFiltersStyles } from './projects-filters.styles'
import { useProjectsFilters } from '../use-projects-filters'
import { TranslationDictionary } from '@plandi/common'

const maxValue = 100

const defaultValueSlider = [0, maxValue]

type Props = {
  translate?: TranslationDictionary['data']
}

export const ProjectsFiltersBuildingHeight: React.FC<Props> = ({
  translate
}) => {
  const classes = useProjectsFiltersStyles()

  const { toBuildingHeight, fromBuildingHeight, setProjectsFiltersDebounce } =
    useProjectsFilters()

  const [sliderBuildingHeightValue, setSliderBuildingHeightValue] = useState([
    fromBuildingHeight ?? 0,
    toBuildingHeight ?? maxValue
  ])

  useEffect(() => {
    if (!toBuildingHeight && !fromBuildingHeight) {
      setSliderBuildingHeightValue(defaultValueSlider)
    }
  }, [toBuildingHeight, fromBuildingHeight])

  const handleChangeBuildingHeightValue = (
    _: React.ChangeEvent<unknown>,
    newValue: number | number[]
  ) => {
    if (Array.isArray(newValue)) {
      setSliderBuildingHeightValue(newValue)

      setProjectsFiltersDebounce({
        fromBuildingHeight: newValue[0],
        toBuildingHeight: newValue[1]
      })
    }
  }

  return (
    <Accordion
      className={classes.accordion}
      classes={{ expanded: classes.accordionExpanded }}
      defaultExpanded
    >
      <AccordionSummary
        className={classes.accordionSummary}
        classes={{
          expanded: classes.accordionSummaryExpanded,
          content: classes.accordionSummaryContent
        }}
        expandIcon={<ExpandMoreIcon />}
      >
        <Typography style={{ fontWeight: 500 }} variant="subtitle1">
          {translate?.shop['projects-page']['building-height']}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <div className={classes.details}>
          <Slider
            value={sliderBuildingHeightValue}
            className={classes.slider}
            min={0}
            color="secondary"
            step={1}
            max={maxValue}
            onChange={handleChangeBuildingHeightValue}
            valueLabelDisplay={
              Math.abs(
                sliderBuildingHeightValue[1] - sliderBuildingHeightValue[0]
              ) < 7
                ? 'auto'
                : 'on'
            }
          />
        </div>
      </AccordionDetails>
    </Accordion>
  )
}
